<template>
  <div class="privacy">
    <p>隐私政策</p>
    <p>生效日期：【】</p>
    <p>更新日期：【】</p>

    <p>生态平台（域名:【】,运营主体：【】及其关联方，简称"我们"）深知个人信息对您的重要性，您的信任对我们非常重要，我们将按照法律法规的规定并参照行业最佳实践保护您的个人信息及隐私安全。我们制定本"隐私政策"并特别提示：希望您在使用生态平台及相关服务前仔细阅读并理解本隐私政策，以便做出适当的选择。</p>
    <p class="bold">本隐私政策将帮助您了解：</p>
    <p>我们会遵循隐私政策收集、使用您的信息，但不会仅因您同意本隐私政策而采用强制捆绑的方式一揽子收集个人信息。</p>
    <p>当您使用或开启相关功能或使用服务时，为实现功能、服务所必需，我们会收集、使用相关信息。除非是为实现基本业务功能或根据法律法规要求所必需的必要信息，您均可以拒绝提供且不影响其他功能或服务。我们将在隐私政策中逐项说明所要收集的信息。</p>
    <p class="bold">如果您未登录帐号，我们会通过设备对应的标识符信息来保障信息推送的基本功能。如果您登录了帐号，我们会根据帐号信息实现信息推送。</p>
    <p>精确地理位置、摄像头（相机）、麦克风、相册（存储）、日历权限，均不会默认开启，<span class="bold">在特定功能或服务场景所必要时，合作平台方（指与我们合作，您通过合作平台跳转至生态平台并使用相关服务的平台）会将您已经明示同意的权限功能开放给我们，您也可以通过合作平台方提供的方式撤回该等授权。特别需要指出的是，即使经过您的授权，我们获得了这些敏感权限，也不会在相关功能或服务不需要时而收集您的信息。您可以通过合作平台提供的方式撤回授权。</span></p>
    <p>本隐私政策适用于生态平台向您提供的产品和服务。<span class="bold">我们及关联公司的产品或服务中使用了生态平台的产品或服务且未设独立隐私权政策的，则本隐私政策同样适用于该部分产品或服务。我们及关联公司就其向您提供的产品或服务单独设有隐私权政策的，则相应产品或服务适用相应隐私权政策。</span></p>
    <p>下文将帮您详细了解我们如何收集、使用、存储、向第三方提供、转让（如适用）与保护个人信息；帮您了解查阅、复制、更正、删除、撤回授权个人信息的方式。本政策与您使用我们的服务关系密切，我们建议您仔细阅读并理解本政策全部内容，作出您认为适当的选择，<span class="bold">有关您个人信息权益的条款重要内容我们已用加粗形式提示，请特别关注。</span></p>
    <p>1. 我们如何收集和使用个人信息</p>
    <p>2. 我们如何使用cookie等同类技术</p>
    <p>3. 数据使用过程中涉及的合作方以及转移、公开个人信息</p>
    <p>4. 我们如何存储个人信息</p>
    <p>5. 我们如何保护个人信息的安全</p>
    <p>6. 算法与自动化决策</p>
    <p>7. 管理您的个人信息</p>
    <p>8. 未成年人条款</p>
    <p>9. 隐私政策的修订和通知</p>
    <p>10. 联系我们</p>

    <p>1. 我们如何收集和使用个人信息</p>
    <p>1.1 登录</p>
    <p>您可以通过【生态平台账号或第三方帐号】登录使用我们平台服务，您将授权我们获取您在<span class="bold">第三方平台的注册手机号</span>、头像及昵称，用于登记、识别您的身份信息，使您可以使用本产品和相关服务。</p>
    <p>1.2 商品或服务信息的展示</p>
    <p>为了让您能够获得更契合您需求的页面信息，<span class="bold">我们会收集您的设备信息、您使用生态平台的情况并存储为服务日志信息、以及其他取得您授权的信息，通过算法模型预测您的偏好特征，匹配您可能感兴趣的商品、服务或其他信息。为满足您的多元需求，我们会在信息展示过程中引入多样化推荐技术，拓展推荐的内容，避免您看到过多同类型内容。请您放心，该等个性化推荐技术不会导致任何不公平交易条件和差异化定价。</span></p>
    <p>设备信息：我们可能会收集您所使用的设备相关信息（包括设备型号、操作系统版本、设备设置、唯一设备标识符、设备环境等软硬件特征信息）、设备所在位置相关信息（包括您授权的GPS位置以及WLAN接入点、蓝牙和基站等传感器信息）。</p>
    <p>服务日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为服务日志保存，包括浏览、点击查看、搜索查询、收藏、加购、交易、售后、关注、分享信息、发布信息，以及IP地址、浏览器类型、电信运营商、使用语言、访问日期和时间。</p>
    <p>您也可以通过搜索来精准地找到您所需要的商品或服务。我们会保留您的搜索内容以方便您重复输入或为您展示与您搜索内容相关联的商品或服务。</p>
    <p>1.3 收藏、加购、关注与分享功能</p>
    <p>在您浏览我们网站或客户端的过程中，您可以选择对感兴趣的商品及/或服务进行收藏、加购（添加至购物车）、与您感兴趣的商家的相关账号建立关注关系、通过我们提供的功能组件向第三方分享商品及/或服务信息。在您使用上述功能的过程中，我们会收集包括您的收</p>
    <p>藏及加购的记录、关注关系、分享历史在内的服务日志信息用于实现上述功能及其他我们明确告知的目的。</p>
    <p>您可以在收藏、购物车中管理或删除您的收藏和加购信息。</p>
    <p>在您分享或接收被分享的信息、参加活动等情形下，生态平台需要在本地访问您的剪切板，读取其中包含的口令、分享码、链接，以实现跳转、分享、活动联动等功能或服务。除此之外，生态平台不会上传您剪切板的其他信息至我们的服务器。为方便您分享或者接收分享的照片，我们会申请和使用您的手机相册权限。拒绝或关闭该权限会导致无法使用图片分享的功能，但不影响平台其它功能的使用。</p>
    <p>有些手机设备的系统会提示应用（App）正在读取剪切板或相册，但该系统提示无法区分是本地处理还是上传，且由于统计方式的差异，不排除误报的可能。因此，如果您发现类似提示并有疑问，请与我们联系，以便我们定位问题。</p>
    <p>1.4 下单及订单管理</p>
    <p>当您在生态平台购买具体商品及/或服务时，我们会通过系统为您生成购买该商品及/或服务的订单。在下单过程中,您需至少提供您的<span>收货人姓名、收货地址、收货人联系电话</span>，同时该订单中会载明您所购买的商品及/或服务信息、具体订单号、订单创建时间、您应支付的金额及支付方式、支付渠道。如您购买跨境进口商品或交通出行类商品、海南免税商品等特殊商品时，您下单过程中，除提供和记录上述信息外，您还可能需要根据国家法律法规或商品及/或服务提供方的要求提供您/出行人的<span class="bold">姓名、身份证号或者提供收货人身份证照片、离开海南岛的行程信息。</span></p>
    <p>您在填写收货地址或退货地址、物流单号时，如选择通过手机剪切板复制粘贴相关信息，生态平台会读取剪切板中的内容帮助您完成信息填写，同时我们会将上述信息回传服务器。我们仅读取和使用您主动复制的信息，不会收集您的其他信息。</p>
    <p>我们收集这些信息是为了进行您的身份核验、支付结算、完成配送、为您查询订单以及提供客服咨询与售后服务，我们还会使用上述信息来判断您的交易是否存在异常以保护您的交易安全以及其他我们明确告知的目的（如：您购买跨境进商品，我们收集这些信息除为前述用途外，还将用于进行您的身份核验、完成清关、查询您跨境电商年度个人限额使用情况）。</p>
    <p>您在使用以上服务中提供的个人身份信息会自动存储为您的常用信息，以便您下次购买特定商品/服务时可以直接选择使用，无需再次填写。您为其他人订购商品或服务时，您需要提供该实际购买人的前述个人信息，并须确保获得其本人的同意；若其中涉及儿童个人信息的，您需在提供前征得对应儿童监护人的同意。</p>
    <p>您可以通过【我】-【≡】-【我的订单】查看和管理您的订单信息。您可以通过【我】-【≡】-【我的订单】-【地址】查看和管理您的收货地址信息。</p>
    <p>1.5 支付功能 </p>
    <p class="bold">支付功能由与我们合作的第三方支付机构向您提供服务。第三方支付机构可能需要收集您的姓名、身份证号、银行卡类型及卡号、手机号码。身份证号和银行卡相关信息是个人敏感信息，这些信息是支付功能所必需的信息，拒绝提供将导致您无法使用该功能，但不影响其他功能的正常使用。生态平台支付功能由【】向您提供服务。当您使用生态平台支付功能时，生态平台支付将会根据法律法规及监管规定收集您的相关信息以为您提供支付服务。</p>
    <p class="bold">如您购买跨境进口商品、海南免税商品，除上述信息外，您授权我们将您的姓名、身份证号提供给支付机构完成身份核验、并由支付机构将订单支付相关信息发送给海关进行申报。</p>
    <p>为使我们及时获悉并确认您的支付进度及状态，为您提供售后与争议解决服务，您同意我们可自您所选择的交易对象或您选择的其他金融机构处收集与支付进度相关的信息。</p>
    <p>1.6 商品或服务的交付功能</p>
    <p>为保证您购买的商品及/或服务能够顺利、安全、准确送达，将会由第三方配送公司或快递柜、快递站点为您完成订单的交付。您知晓并同意上述服务方会不可避免地获知及使用您的订单信息、收货信息、联系人信息，以保证您的商品能够安全送达。</p>
    <p>如您购买跨境进口商品，为保证您购买的商品及/或服务能够顺利、安全、准确清关并送达，将会由第三方服务商及/或第三方配送公司为您完成订单的海关报关及/或交付。您知晓并同意相应第三方服务商及/或物流配送主体会在上述环节内不可避免地获知及使用您的订单信息（包括您的<span class="bold">身份证号、姓名或收件人身份证照片</span>），以保证您订购的商品能够顺利清关并安全送达。</p>
    <p>为使我们及时获悉并确认交付进度及状态，向您提供售后与争议解决服务，您同意我们可自物流或清关相关服务主体处收集与交付进度相关的信息。</p>
    <p>如您购买跨境进口商品为使我们及时获悉并确认清关、交付进度及状态，向您提供售后与争议解决服务，您同意我们可自第三方服务商及/或物流相关服务主体处收集与清关、交付进度相关的信息。</p>
    <p>1.7 客服及售后功能</p>
    <p>当您与我们联系或提出售中售后、争议纠纷处理申请时，为了保障您的账户及系统安全，<span class="bold">我们需要您提供必要的个人信息以核验您的身份。</span></p>
    <p class="bold">为便于商家或平台与您联系、尽快帮助您解决问题或记录相关问题的处理方案及结果，我们可能会保存、使用您与商家或平台的通信/通话记录及相关内容（包括帐号信息、订单信息、您为了证明相关事实提供的其他信息，联系方式信息，或您主动提供的其他信息），如果您针对具体订单进行咨询、投诉或提供建议的，我们会使用您的帐号信息和订单信息及订单中的联系电话。</p>
    <p>为了提供服务及改进服务质量的合理需要，我们还可能使用您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息。</p>
    <p>1.8 号码保护功能</p>
    <p>为更好保护用户个人信息，我们为用户在相应场景提供号码保护功能。为保证服务体验，在订单履行过程中，商家通过号码保护功能与您联系通话时，通话信息可能会被录音。</p>
    <p>a. 有权机关依法定程序调取；</p>
    <p>b. 被录音的一方持司法机关出具的法律文件依法调取。</p>
    <p>受网络状态稳定性等限制，极端情况下，可能会出现无法录音或部分录音无法听清等录音失败情形。</p>
    <p>如对号码保护功能有任何疑问，可通过本政策第10条的途径联系我们。</p>
    <p>1.9 评价等信息公开发布功能</p>
    <p>您可通过我们为您提供的评价及其他信息发布功能公开发布信息，包括作为用户可发布图文内容，我们可能会根据您的服务日志信息判断您是否可享受对应功能权限。</p>
    <p class="bold">您可通过我们为您提供的评价及其他信息发布功能公开发布信息，包括作为用户可发布图文内容，我们可能会根据您的服务日志信息判断您是否可享受对应功能权限。</p>
    <p>1.10 消息通知</p>
    <p>我们可能通过短信、电话等形式，向您提供的联系方式，发送身份验证、服务通知、订单信息、用户使用体验调研、您可能感兴趣的服务、功能或活动的商业性信息及其他商品或服务信息。如您不愿接收我们的商业性信息及其他商品或服务信息，您可以通过短信中提供的退订方式或通过我们的客服进行退订或关闭。</p>
    <p>1.11 运营与安全运行/保障</p>
    <p>1.11.1 运营与安全保障</p>
    <p>我们致力于为您提供安全、可信的产品与使用环境，提供优质而可靠的服务与信息是我们的核心目标。为了维护我们服务的正常运行，保护您或其他用户或公众的合法利益免受损失，我们会收集用于维护产品或服务安全稳定运行的必要信息。</p>
    <p>1.11.2 设备信息与日志信息</p>
    <p>a. 为了保障软件与服务的安全运行、运营的质量及效率，我们会收集您的硬件型号、操作系统版本号、设备标识符（Android如IMEI、AndroidID、OAID、IMSI、ICCID、GAID、MEID、硬件序列号、iOS如IDFV、IDFA；不同的标识符在有效期、是否可由用户重置以及获取方式方面会有所不同）、网络设备硬件地址（MAC地址）、IP 地址、WLAN接入点（如SSID，BSSID）、蓝牙（Bluetooth）、基站、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志、设备传感器数据。</p>
    <p>b. 为了预防恶意程序、保障运营质量及效率，我们会收集安装的应用信息或正在运行的进程信息、应用程序的总体运行、使用情况与频率、应用崩溃情况、总体安装使用情况、性能数据、应用来源。</p>
    <p>c. 我们可能使用您的账户信息、设备信息、服务日志信息以及我们关联方、合作方在获得您授权或依法可以提供的信息，用于判断账户及交易安全、进行身份验证、识别违法违规情况、检测及防范安全事件，并依法采取必要的记录、分析、处置措施。</p>
    <p>1.12 其他</p>
    <p class="bold">若您提供的信息中含有其他用户的个人信息，在向平台提供这些个人信息之前，您需确保您已经取得合法的授权。若其中涉及儿童个人信息的，您需在提供前取得对应儿童监护人的同意，前述情形下监护人有权通过本政策第10条的途径联系我们，要求更正或删除涉及儿童个人信息的内容。</p>
    <p>若我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，或者我们主动从第三方处获取您的个人信息，均会事先获得您的同意。</p>
    <p>若我们从第三方处间接获取您的信息的，我们会在收集前明确以书面形式要求该第三方在已依法取得您同意后收集个人信息，并向您告知共享的信息内容，且涉及敏感信息的在提供给我们使用前需经过您的明确确认，要求第三方对个人信息来源的合法性和合规性作出承诺，如第三方有违反行为的，我们会明确要求对方承担相应法律责任；同时，我们会使用不低于我们对自身用户个人信息同等的保护手段与措施对间接获取的个人信息进行保护。</p>
    <p>1.13 收集、使用个人信息目的变更</p>
    <p>请您了解，随着我们业务的发展，可能会对生态平台的功能和提供的服务有所调整变化。原则上，当新功能或服务与我们当前提供的功能或服务相关时，收集与使用的个人信息将与原处理目的具有直接或合理关联。在与原处理目的无直接或合理关联的场景下，我们收集、使用您的个人信息，会再次按照法律法规及国家标准的要求以页面提示、交互流程、协议确认方式另行向您进行告知说明，并征得您的同意。</p>
    <p>1.14 征得授权同意的例外</p>
    <p>请您理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用您的个人信息不必事先征得您的授权同意：</p>
    <p>a. 与我们履行法律法规规定的义务相关的；</p>
    <p>b. 与国家安全、国防安全直接相关的；</p>
    <p>c. 与公共安全、公共卫生、重大公共利益直接相关的；</p>
    <p>d. 与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
    <p>e. 出于维护您或他人的生命、财产等重大合法权益但又很难得到本人授权同意的；</p>
    <p>f. 您自行向社会公众公开的个人信息；</p>
    <p>g. 根据个人信息主体要求签订和履行合同所必需的；</p>
    <p>h. 从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
    <p>i. 用于维护软件及相关服务的安全稳定运行所必需的，例如发现、处置软件及相关服务的故障；</p>
    <p>j. 为开展合法的新闻报道所必需的；</p>
    <p>k. 为学术研究机构，基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
    <p>l. 法律法规规定的其他情形。</p>
    <p class="bold">特别提示您注意，如信息无法单独或结合其他信息识别到您的个人身份，其不属于法律意义上您的个人信息；当您的信息可以单独或结合其他信息识别到您的个人身份时或我们将无法与任何特定个人信息建立联系的数据与其他您的个人信息结合使用时，这些信息在结合使用期间，将作为您的个人信息按照本隐私政策处理与保护。</p>

    <p>2. 我们如何使用cookie等同类技术</p>
    <p>Cookie和设备信息标识等同类技术是互联网中普遍使用的技术。当您使用生态平台及相关服务时，我们可能会使用相关技术向您的设备发送一个或多个 Cookie 或匿名标识符，以收集、标识和存储您访问、使用本产品时的信息。我们承诺，不会将 Cookie 用于本隐私政策所述目的之外的任何其他用途。我们使用 Cookie 和同类技术主要为了实现以下功能或服务：</p>
    <p>2.1 保障产品与服务的安全、高效运转</p>
    <p>我们可能会设置认证与保障安全性的 cookie 或匿名标识符，使我们确认您是否安全登录服务，或者是否遇到盗用、欺诈及其他不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。</p>
    <p>2.2 帮助您获得更轻松的访问体验</p>
    <p>使用此类技术可以帮助您省去重复您填写个人信息、输入搜索内容的步骤和流程。</p>
    <p>2.3 为您推荐、展示、推送您可能感兴趣的内容或帐号</p>
    <p>2.3.1 我们可能会利用 Cookie 和同类技术了解您的偏好和使用习惯，进行数据分析，以改善产品服务、推荐用户感兴趣的信息或功能，并优化您对广告的选择。</p>
    <p>2.3.2 在生态平台的分享页中，我们可能会使用cookie对浏览活动进行记录，用于向您推荐信息和排查崩溃、延迟的相关异常情况以及探索更好的服务方式。</p>

    <p>2.4 cookie的清除</p>
    <p>大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以在浏览器设置功能中进行相应的数据清除操作。如您进行清除，可能因为这些修改，您可能无法使用依赖于Cookie由公司提供的服务或相应功能。</p>

    <p>3. 数据使用过程中涉及的合作方以及转移、公开个人信息</p>
    <p>3.1 数据使用过程中涉及的第三方</p>
    <p>3.1.1 原则</p>
    <p><span class="bold">a. 合法原则：</span>与合作方合作过程中涉及数据使用活动的，必须具有合法目的、符合法定的合法性基础。如果合作方使用信息不再符合合法原则，则其不应再使用您的个人信息，或在获得相应合法性基础后再行使用。</p>
    <p><span class="bold">b. 正当与最小必要原则：</span>数据使用必须具有正当目的，且应以达成目的必要为限。</p>
    <p><span class="bold">c. 安全审慎原则：</span>我们将审慎评估合作方使用数据的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护数据安全。</p>
    <p>3.1.2 委托处理</p>
    <p>对于委托处理个人信息的场景，我们会与受托人根据法律规定签署相关处理协议，并对受托人的个人信息处理活动进行监督。</p>
    <p>3.1.3 共同处理</p>
    <p>对于共同处理个人信息的场景，我们会与合作方根据法律规定签署相关协议并约定各自的权利和义务，确保在使用相关个人信息的过程中遵守法律的相关规定、保护数据安全。</p>
    <p>3.1.4 合作方的范围</p>
    <p>若具体功能和场景中涉及由我们的关联方、第三方提供服务，则合作方范围包括我们的关联方与第三方。</p>
    <p>3.1.5实现功能或服务的信息处理</p>
    <p>为完成服务事项，我们可能会与必要的合作方处理或委托处理您的订单信息、账户信息、设备信息以及使用我们产品/服务的日志信息，以保障为您提供的服务顺利完成。但我们严格遵守合法、正当、必要的原则，并且只会处理提供服务所必要的个人信息。场景如下：</p>
    <p>a. 商品或技术服务的供应商,供货方或提供基础设施技术服务、履约技术服务、物流配送服务、支付服务、数据处理等第三方机构会在必要范围内处理您在平台中提交或留存的个人信息。上述个人信息的委托处理均是以实现我们为您提供的购物功能为目的，比如我们必须与物流服务商提供您的订单信息才能安排送货；或者我们需要将您的订单号和订单金额与第三方支付机构共享以实现其确认您的支付指令并完成支付等。 </p>
    <p>如果您购买跨境进口商品，第三方商家可能由境外发货，并委托境外物流服务商提供物流服务。我们需要将您的订单信息有关的必须要信息提供给商家委托的服务商，以实现发货和物流配送服务。</p>
    <p>b. 第三方商家为提供商品交易服务和售后服务等需要，将会收集您的订单信息及与订单交易有关的必要信息。</p>
    <p>第三方商家还可能会委托他方发货，我们需要将您的订单信息与交易有关的必须要信息提供给商家委托的发货方，以便实现向您交付商品。</p>
    <p>c. 支付机构,支付功能由与我们合作的第三方支付机构向您提供服务。第三方支付机构可能需要使用您的姓名、身份证号、银行卡类型及卡号、有效期及手机号码。身份证号、银行卡号、有效期是个人敏感信息，这些信息是支付功能所必需的信息，拒绝提供将导致您无法使用该功能，但不影响其他功能的正常使用。</p>
    <p>d. 与我们进行推广合作的合作方。有时我们会与其他合作方向使用我们产品/服务的用户群提供商品/服务的推广与促销。进行产品/服务推广和提供促销服务的合作方可能需要使用去标识化或匿名化后的设备、网络、标签以及使用我们产品/服务的日志信息以实现前述目的，并分析与优化推广的有效触达率。前述合作方可能将上述信息与其合法获取的其他数据相结合，以优化相关推广、促销服务的效果，我们会要求其对信息的使用遵循合法、正当、必要原则，保障用户合法权利不受侵犯。</p>
    <p>e. 如果我们或第三方（包括第三方商家）为您投保退货运费险，为实现相应保障服务，我们会向提供该服务的保险机构提供必要的订单信息，请您放心，我们会对提供的信息做去标识化处理，使得保险机构难以识别您的身份，我们也不会提供您的联系方式或任何财产信息。</p>
    <p>f. 我们还会向合法持有您个人信息的关联方或第三方合作机构（包括支付机构、清算交易机构、金融机构、个人征信机构）获取您的消费交易类画像、产品/服务的日志信息或个人信用评分或去标识化信息。基于您在平台中的历史交易类信息、产品/服务的日志信息，我们会进行消费行为分析以便为您提供更优质的服务。以上信息将可能用于平台内部数据分析、服务或产品推荐、电商风控、与电商相关的支付风控、反洗钱及电商先用后付等服务的提供。</p>
    <p>g. 基于实现特殊类型商品或服务交易以及其他依法需要核验用户真实身份的场景（包括依法保护未成年人权益、打击电信网络诈骗）的必要，我们会向合法持有您个人信息的关联方获取您账号的必要认证信息。</p>
    <p>h. 订单信息处理,为了便于您查询订单，您授权平台将您的订单信息同步至合作平台方，由您查询由该合作平台跳转完成的订单信息；您可通过合作平台取消上述授权。</p>
    <p>i. 您授权全球购跨境电商平台将您帐号下身份信息、优惠信息、交易相关信息提供至生态平台，便于您在生态平台查看、享受各项优惠，并且便于生态平台协助完成全球购跨境电商平台授权的各项服务（包括客服咨询、平台售后功能等）。如您在合作平台下单购买跨境进口商品，您授权全球购跨境电商平台将您的订单信息同步至合作平台展示，以便您查看。</p>
    <p>3.1.6 实现安全与分析统计的信息处理</p>
    <p>a. 保障使用安全：我们非常重视帐号与服务安全，为保障您和其他用户的帐号与财产安全，使您和我们的正当合法权益免受不法侵害，我们和关联公司或服务提供商可能会提供必要的设备、帐号及日志信息。</p>
    <p>b. 分析产品使用情况：为分析我们服务的使用情况，提升用户使用的体验，可能会与关联方或第三方提供产品使用情况（崩溃、闪退）的统计性数据，这些数据难以与其他信息结合识别您的个人身份。</p>
    <p>3.2 转移</p>
    <p>随着我们业务的持续发展，我们将有可能进行合并、收购、资产转让，您的个人信息有可能因此而被转移。在发生前述变更时，我们将按照法律法规及不低于本隐私政策所载明的安全标准要求继受方保护您的个人信息，否则我们将要求继受方重新征得您的授权同意。</p>
    <p>3.3 公开</p>
    <p>a. 我们不会公开您的信息，除非遵循国家法律法规规定或者获得您的同意。我们公开您的个人信息会采用符合行业内标准的安全保护措施。</p>
    <p>b. 对违规帐号、欺诈行为进行处罚公告时，我们会披露相关帐号的信息。</p>
    <p>3.4 依法豁免征得同意提供、公开的个人信息</p>
    <p>请您理解，在下列情形中，根据法律法规及国家标准，我们提供、公开您的个人信息无需征得您的授权同意：</p>
    <p>a. 为订立、履行您作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；</p>
    <p>b. 为履行法定职责或者法定义务所必需；</p>
    <p>c. 与国家安全、国防安全直接相关的；</p>
    <p>d. 与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
    <p>e. 为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</p>
    <p>f. 为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</p>
    <p>g. 依照相关法律规定处理您自行公开或者其他已经合法公开的个人信息；</p>
    <p>i. 法律、行政法规规定的其他情形。</p>

    <p>4. 我们如何存储个人信息</p>
    <p>4.1 存储地点 </p>
    <p>我们依照法律法规的规定，将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。目前，我们不会将上述信息传输至境外，如果我们向境外传输，我们将会遵循相关国家规定或者征求您的同意。</p>
    <p>4.2 存储期限</p>
    <p>4.2.1 我们仅在为提供平台服务之目的所必需的期间内保留您的个人信息。</p>
    <p>4.2.2 如果您注销帐户、主动删除个人信息或超出必要的期限后，我们将对您的个人信息进行删除或匿名化处理，但以下情况除外：</p>
    <p>a. 遵从法律法规有关信息留存的要求（例如：《电子商务法》规定：商品和服务信息、交易信息保存时间自交易完成之日起不少于三年）。</p>
    <p>b. 出于财务、审计、争议解决等目的需要合理延长期限的。</p>

    <p>5. 我们如何保护个人信息的安全</p>
    <p>5.1 我们非常重视您个人信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护您的个人信息，防止您提供的个人信息被不当使用或未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。</p>
    <p>5.2 我们会使用不低于行业同行的加密技术、匿名化处理及相关合理可行的手段保护您的个人信息，并使用安全保护机制防止您的个人信息遭到恶意攻击。</p>
    <p>5.3 我们会建立专门的安全部门、安全管理制度、数据安全流程保障您的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人信息，并适时对数据和技术进行安全审计。</p>
    <p>5.4 尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。</p>
    <p>5.5 您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的帐号密码及相关个人信息透露给他人。</p>
    <p>5.6 我们会制定应急处理预案，并在发生用户信息安全事件时立即启动应急预案，努力阻止这些安全事件的影响和后果扩大。一旦发生用户信息安全事件（泄露、丢失）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已经采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我们将及时将事件相关情况以推送通知、邮件、信函、短信及相关形式告知您，难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照相关监管部门要求，上报用户信息安全事件的处置情况。</p>
    <p>5.7 您一旦离开生态平台及相关服务，浏览或使用其他网站、服务及内容资源，我们将没有能力和直接义务保护您在生态平台及相关服务之外的软件、网站提交的任何个人信息，无论您登录、浏览或使用上述软件、网站是否基于生态平台的链接或引导。</p>

    <p>6. 算法与自动化决策</p>
    <p>为了向您展示、推荐相关性更高的信息，提供更契合您要求的服务，生态平台会为您提供个性化推荐服务，以下我们将向您详细说明该个性化推荐服务的运行机制以及您实现控制的方式。</p>
    <p>6.1 个性化推荐的机制</p>
    <p>a. 我们提供个性化推荐服务的范围包括商品及/或服务信息展示，提供搜索结果等。</p>
    <p>b. 为了预测您的偏好，我们可能会收集、使用您的设备信息、位置信息以及在使用产品时的行为信息，行为信息包括您在访问/使用产品时的点击、关注、收藏、搜索、查询、浏览、下载、分享及交易的操作相关记录。我们会对上述信息进行自动分析和计算，并根据计算结果从信息候选池中筛选出您可能更感兴趣的内容进行推送。</p>
    <p>c. 我们会根据您在使用产品过程中的浏览行为对推荐模型进行实时反馈，不断调整优化推荐结果，更好地向您提供优质内容。</p>
    <p>6.2 个性化推荐的控制与管理</p>
    <p>我们会利用推荐算法对您浏览的信息内容进行个性化推荐和展示，您可通过下述方式对信息内容的个性化推荐进行控制：</p>
    <p>a. 自主决定接收个性化推送资讯：您可通过我们的合作平台方的操作页面，选择一键全部关闭个性化推荐，当您选择关闭全部个性化推荐后，将不再向您展示“推荐”频道，您无法享受个性化推荐服务，但仍可继续浏览平台内非个性化推荐内容。</p>
    <p>b. 当没有您感兴趣信息时，您也可以在搜索栏输入感兴趣的关键词，点击并阅读搜索结果。</p>

    <p>7. 管理您的个人信息</p>
    <p>我们非常重视您对个人信息的管理，并尽全力保护您对于您个人信息的查阅、复制、更正、补充、删除、撤回同意授权、注销账号、投诉举报以及设置隐私功能等权利，以使您有能力保障您的隐私和信息安全。</p>
    <p>7.1 改变或撤回授权范围</p>
    <p>a. 改变或撤回敏感权限设置：您可以在合作平台的权限管理相关功能中关闭相关权限，以改变同意范围或撤回您的授权。撤回授权后我们将不再收集与该权限相关信息。</p>
    <p>b. 改变或撤回授权的信息处理：特定的业务功能和服务将需要您的信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的功能和服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响我们此前基于您的授权而开展的个人信息处理。</p>
    <p>7.2 查阅、复制、更正您的信息</p>
    <p>除法律法规另有规定外，您有权查询、复制、更正我们收集的您的个人信息，您可以通过第10条的途径联系我们进行操作。</p>
    <p>7.3 删除您的信息</p>
    <p>在以下情形中，您可以向我们提出删除个人信息的请求，您可以通过第10条的途径联系我们进行操作：</p>
    <p>1、如果我们处理个人信息的行为违反法律法规；</p>
    <p>2、如果我们收集、使用您的个人信息，却未征得您的明确同意；</p>
    <p>3、如果我们处理个人信息的行为严重违反了与您的约定；</p>
    <p>4、如果您不再使用我们的产品或服务，或您主动注销了帐号；</p>
    <p>5、如果我们永久不再为您提供产品或服务。</p>
    <p>特别提示您注意，出于安全性和身份识别的考虑，您可能无法自主修改注册时提交的某些初始注册信息或依法要求我们存储的信息。</p>
    <p>当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。</p>
    <p>7.4 注销帐号</p>
    <p>您可以通过第10条的途径与我们联系申请注销您的账号，我们将会在收到您的申请后及时进行处理，并在15个工作日或法律法规要求的时限内回复您的请求。在您注销账号前，我们将验证您的个人身份、安全状态、设备信息等。您知悉并理解，注销账号是不可逆的行为，当您注销账号后，我们将删除有关您的相关信息或进行匿名化处理，但法律法规另有规定的除外。您注销账号后，我们将删除有关您的相关信息或进行匿名化处理，但法律法规另有规定的除外</p>
    <p>7.5 意见反馈和投诉举报</p>
    <p>您可以按照我们公示的制度进行投诉或举报。如果您有任何意见或您认为您的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索，您可以通过第10条的途径与我们联系。</p>
    <p>7.6 访问隐私政策</p>
    <p>a. 您可以在【】界面查看本隐私政策全部内容。</p>
    <p>b. 请您了解，本隐私政策中所述的收藏、关注、分享、点击查看、搜索及相关服务可能会根据您所使用的手机型号、系统版本、软件应用程序版本、移动客户端等因素而有所不同。最终的产品和服务以您所使用的平台软件及相关服务为准。</p>
    <p>7.7 停止运营向您告知</p>
    <p>如我们停止运营，我们将及时停止收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对所持有的您的个人信息进行删除或匿名化处理。</p>
    <p>7.8 响应您的上述请求</p>
    <p>对于您或可能的您的监护人、近亲属及其他有权主体向我们提出上述请求，以及中华人民共和国法律与其他适用法律规定的您的相关个人信息权利，您均可以第10条的途径与我们联系。</p>
    <p>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份，我们将在收到您反馈并验证您的身份后的15个工作日内答复您的请求。</p>
    <p>以下情形下我们可能不会响应您提出的更正/修改、删除、注销、撤回同意、索取信息的请求：</p>
    <p>1) 与我们履行法律法规规定的义务相关的；</p>
    <p>2) 与国家安全、国防安全直接相关的；</p>
    <p>3) 与公共安全、公共卫生、重大公共利益直接相关的；</p>
    <p>4) 与刑事侦查、起诉、审判和执行判决等直接相关的；</p>
    <p>5) 我们有充分证据表明个人信息主体存在主观恶意或滥用权利的；</p>
    <p>6) 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</p>
    <p>7) 响应您的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；</p>
    <p>8) 涉及商业秘密的。</p>

    <p>8. 未成年人条款</p>
    <p>8.1 若您是未满18周岁的未成年人，在使用生态平台及相关服务前，应在您的父母或其他监护人监护、指导下共同阅读并同意本隐私政策。</p>
    <p>8.2 若您是未满14周岁的未成年人的监护人，在使用生态及相关服务前，应为您的被监护人阅读并同意本隐私政策。</p>
    <p>8.3 我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下收集、使用或披露未成年人的个人信息；如果我们发现在未事先获得可证实的父母或其他监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关信息。</p>
    <p>8.4 若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本隐私政策公示的联系方式与我们联系。</p>

    <p>9. 隐私政策的修订和通知</p>
    <p>9.1 为了给您提供更好的服务，生态平台及相关服务将不时更新与变化，我们会适时对本隐私政策进行修订，这些修订构成本隐私政策的一部分并具有等同于本隐私政策的效力，未经您明确同意，我们不会削减您依据当前生效的本隐私政策所应享受的权利。</p>
    <p>9.2 本隐私政策更新后，我们会在生态平台发出更新版本，并在更新后的条款生效前通过公告或其他适当的方式提醒您更新的内容，以便您及时了解本隐私政策的最新版本。</p>

    <p>10. 联系我们</p>
    <p>10.1 如果您认为您的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索，您可以在【我】-【≡】-【我的客服】，进入用户反馈界面与我们联系。</p>
    <P>我们核查后会在十五个工作日内反馈您的投诉与举报。</P>
    <p>我们核查后会在十五个工作日内反馈您的投诉与举报。</p>
    <P>a) 发送邮件至【】</P>
    <P>b) 邮寄至【】法务部数据安全与隐私保护中心</P>
    <P>我们将尽快审核您提出的问题或建议，并在验证您的用户身份后的十五个工作日内回复。</P>
  </div>
</template>

<script>
export default {
  name: "privacy",
};
</script>

<style scoped lang="less"></style>
